(function(){
  var fmt=function(c){var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
    try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cur}).format(c/100)}catch(e){return '$'+(c/100).toFixed(2)}};
  document.querySelectorAll('.shop-card[data-handle]').forEach(function(el){
    var h=el.getAttribute('data-handle').trim();
    fetch('/products/'+h+'.js').then(function(r){if(!r.ok)throw 0;return r.json()}).then(function(p){
      var img=p.featured_image?p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i,'_200x200$1'):'';
      var sale=p.compare_at_price&&p.compare_at_price>p.price;
      var a=document.createElement('a');
      a.className='shop-card'+(p.available?'':' shop-card--soldout');
      a.href='/products/'+h;
      a.setAttribute('data-shop-card',h);
      a.innerHTML='<img class="shop-card__img" loading="lazy" width="84" height="84" alt="'+p.title.replace(/"/g,'&quot;')+'" src="'+img+'">'
        +'<span class="shop-card__body">'
        +'<span class="shop-card__title">'+p.title+'</span>'
        +'<span class="shop-card__price">'+fmt(p.price)+(sale?' <s>'+fmt(p.compare_at_price)+'</s>':'')+'</span></span>'
        +'<span class="shop-card__btn">'+(p.available?'Shop this set →':'Sold out')+'</span>';
      el.replaceWith(a);
    }).catch(function(){el.remove();});   // handle sai → card biến mất, không vỡ bài
  });
})();
(function(){
  var items=document.querySelectorAll('.faq details');
  if(!items.length)return;
  var qs=[];
  items.forEach(function(d){
    var q=d.querySelector('summary'),a=d.querySelector('p');
    if(q&&a)qs.push({"@type":"Question","name":q.textContent.trim(),"acceptedAnswer":{"@type":"Answer","text":a.textContent.trim()}});
  });
  if(!qs.length)return;
  var s=document.createElement('script');s.type='application/ld+json';
  s.textContent=JSON.stringify({"@context":"https://schema.org","@type":"FAQPage","mainEntity":qs});
  document.head.appendChild(s);
})();